module.exports = __webpack_public_path__ + "img/sub-title2.9879baac.png";